export const addElement = ({ commit }, payload) => {
  return new Promise((resolve) => {
    commit('ADD', Object.assign({}, payload))
    resolve()
  })
}

export const editElement = ({ commit }, { index, value }) => {
  return new Promise((resolve) => {
    commit('EDIT', {
      index,
      value: Object.assign({}, value)
    })
    resolve()
  })
}

export const removeElement = ({ commit }, index) => {
  return new Promise((resolve) => {
    commit('REMOVE', index)
    resolve()
  })
}

export const empty = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_LIST', [])
    resolve()
  })
}
